<template>
  <div v-if="item">
    {{ item.name }}：
    <el-input :disabled="!control" size="mini" style="width: 40%" type="number" v-model="item.pointValue"/>
    <el-button size="mini" @touchstart="change(item.id,item.pointValue)" @click="change(item.id,item.pointValue)" style="margin-left: 10px;">确认</el-button>
  </div>
</template>

<script>
import lodash from "lodash";

export default {
  props: ['pointInfo', 'isControl', 'deviceInfo'],
  mounted() {
    this.id = this.deviceInfo.id
    this.item = lodash.cloneDeep(this.pointInfo)
    console.log(this.item)
    this.control = this.isControl
  },
  watch: {
    pointInfo: {
      handler(val) {
        this.item = val
      }
    },
    deviceInfo: {
      handler(val) {
        this.id = val.id
      }
    },
    isControl: {
      handler(val) {
        this.control = val
      }
    },
  },
  name: "InputControl",
  data() {
    return {
      item:{},
      control: true,
      id: ''
    }
  },
  methods: {
    change(id, valueBut) {
      this.$emit('change', id, valueBut, false)
      this.item = lodash.cloneDeep(this.pointInfo)
    },
  }
}
</script>

<style scoped>

</style>
